import { NOTIFICATION_SEVERITY_TYPES, NOTIFICATION_TYPES } from '@/constants/constants.js'

// Notification kinds that are shown as modals and can be grouped into the multi notification flow.
export const SYSTEM_NOTIFICATION_FLOW_KINDS = [NOTIFICATION_TYPES.MODAL, NOTIFICATION_TYPES.REFRESH]

// Order in which the notifications are shown: warning, notice (Yeniliklerimiz), info, error.
export const SYSTEM_NOTIFICATION_SEVERITY_PRIORITY = [
  NOTIFICATION_SEVERITY_TYPES.WARNING,
  NOTIFICATION_SEVERITY_TYPES.SUCCESS,
  NOTIFICATION_SEVERITY_TYPES.INFO,
  NOTIFICATION_SEVERITY_TYPES.DANGER
]

// The welcome modal is shown when the retailer has at least this many notifications waiting.
export const SYSTEM_NOTIFICATION_WELCOME_THRESHOLD = 3

export const SYSTEM_NOTIFICATION_STORAGE_KEYS = {
  WELCOME_SHOWN_DATE: 'retailerSystemNotificationWelcomeShownDate',
  POSTPONED: 'retailerSystemNotificationPostponed'
}

export const SYSTEM_NOTIFICATION_SEVERITY_CONFIG = {
  [NOTIFICATION_SEVERITY_TYPES.WARNING]: {
    icon: 'mdi-alert-outline',
    modifier: 'warning',
    titleKey: 'constants.constants.notification_severity_types.warning',
    categoryKey: 'components.system_notification_modal.category.warning'
  },
  [NOTIFICATION_SEVERITY_TYPES.SUCCESS]: {
    icon: 'mdi-party-popper',
    modifier: 'notice',
    titleKey: 'constants.constants.notification_severity_types.notice',
    categoryKey: 'components.system_notification_modal.category.notice'
  },
  [NOTIFICATION_SEVERITY_TYPES.INFO]: {
    icon: 'mdi-information-outline',
    modifier: 'info',
    titleKey: 'constants.constants.notification_severity_types.info',
    categoryKey: 'components.system_notification_modal.category.info'
  },
  [NOTIFICATION_SEVERITY_TYPES.DANGER]: {
    icon: 'mdi-alert-circle-outline',
    modifier: 'error',
    titleKey: 'constants.constants.notification_severity_types.error',
    categoryKey: 'components.system_notification_modal.category.error'
  }
}
